import * as _ from "lodash";
import { Action } from "redux";
import * as toastr from "toastr";
import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as querystring from "querystring";

import { loadUpdatedRecurrencePatternDescriptionSuccessAction, updateRecurrencePatternAction } from "./recurrenceActions";

import { DataService } from "../data/DataService";

import { IEvent } from "../classes/event";
import { IExportFile } from "../classes/exportFile";
import { IOption } from "../classes/option";

import * as types from "./actionTypes";

import { beginAjaxCall } from "./ajaxActions";

import { IEventsResponse } from "../classes/data";

import { IState } from "../classes/state";

import JSFileDownload from "js-file-download";

import { parse, parseDate } from "../reducers/changeTimePeriod";

const actionCreator = actionCreatorFactory();

export const loadCalendarEventsSuccess = actionCreator<IEvent[]>(types.LOAD_CALENDAR_EVENTS_SUCCESS);
export const loadCalendarEventDetailSuccess = actionCreator<IEvent>(types.LOAD_CALENDAR_EVENT_DETAIL_SUCCESS);
export const clearCalendarEvents = actionCreator<{}>(types.CLEAR_CALENDAR_EVENTS);
export const unregisterFromEventSuccess = actionCreator<IEvent>(types.UNREGISTER_FROM_EVENT_SUCCESS);
export const deleteEventSuccess = actionCreator<{}>(types.DELETE_EVENT_SUCCESS);
export const clearCurrentCalendarEvent = actionCreator(types.CLEAR_CURRENT_EVENT);

const dataService = new DataService();

export function clearEvents() {
  return (dispatch) => {
    dispatch(clearCalendarEvents(""));
  };
}

export function requestEventsFromService(portletInstanceId: number, calendarId: number, otherCalendarIds: number[], localFromDate: Date, localToDate: Date, filterField: string, filterTerm: string, category: string, filterOptions: IOption[]) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.events(portletInstanceId, calendarId, otherCalendarIds, localFromDate, localToDate, filterField, filterTerm, category, filterOptions).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // Verify incoming event data.
      let events: IEvent[] = [];
      events = verifyEvents(response);

      // If all's well, dispatch action with the requested events.
      dispatch(loadCalendarEventsSuccess(events));

    }); // .catch((error) => {
    // toastr.error(error); TO DO Add some logging that event requets failed here?
    // throw error;
    // });
  };
}

export function requestEventDetailFromService(portletInstanceId: number, calendarId: number, eventId: number, localStartDate: Date, localEndDate: Date) {
  return (dispatch) => {

    // dispatch(clearEvents());
    dispatch(beginAjaxCall());

    // Recurring Two-way and ICAL calendar events are not all saved individually into the database. When we request the full list of events for a time period, we generate the
    // additional recurences of the event on the fly, but that info is not avilable when requesting the details for a single occurence of the event - which results in
    // always returning only the first recurrence of the event. To get around this, when the user clicks on the details of a recurrence of a two-way calendar event,
    // we pass along the localStartdate and localEndDate of the event in the querystring, and update the original event's data here:
    let theLocation = location.search;
    if (theLocation && theLocation.length > 0 && theLocation[0] === "?") { theLocation = theLocation.substring(1, theLocation.length); }
    const querystringObj = querystring.parse(theLocation);
    if (querystringObj) {
       if (querystringObj.localStartDate) {
        const qsLocalStartDate = new Date(querystringObj.localStartDate.toString());
        localStartDate = qsLocalStartDate;
      }
      if (querystringObj.localEndDate) {
        localEndDate = new Date(querystringObj.localEndDate.toString());
      }
    }

    return dataService.eventDetail(portletInstanceId, calendarId, eventId, localStartDate, localEndDate).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // Verify incoming event data.
      const event: IEvent = response;
      event.localStartDate = parseDate(event.localStartDate);   // Parse via date_fns to maintain time zone.
      event.localEndDate = parseDate(event.localEndDate);       // Parse via date_fns to maintain time zone.
      event.dateOfFirstEventInRecurrence = parseDate(event.dateOfFirstEventInRecurrence);

      // If all's well, dispatch action with the requested events.
      dispatch(loadCalendarEventDetailSuccess(event));

      // Also set the event's recurrence pattern and description in global state so that it will be accessible by the RecurrenceModal.
      dispatch(updateRecurrencePatternAction(event.recurrencePattern));
      dispatch(loadUpdatedRecurrencePatternDescriptionSuccessAction(event.recurrenceDescription));

    }); // .catch((error) => {
    // toastr.error(error); TO DO Add some logging that event requets failed here?
    // throw error;
    // });
  };
}

export function exportFileFromService(calendarId: number, eventId: number, isAllDay: boolean, title: string, location: string, description: string, category: string, localStartDate: Date, localEndDate: Date) {
  return (dispatch) => {

    return dataService.exportFile(calendarId, eventId, isAllDay, title, location, description, category, localStartDate, localEndDate).then((response: any) => {
      if (response.d !== undefined) { response = response.d; }

      const exportFile: IExportFile = response;
      const jsDownload: JSFileDownload = new JSFileDownload(exportFile.fileData, exportFile.fileName, exportFile.fileType);
    });
  };
}

export function unregisterFromEventFromService(eventId: number, calendarId: number, localStartDate: Date, localEndDate: Date) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.unregisterFromEvent(eventId, calendarId, localStartDate, localEndDate).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // refresh event
      const event: IEvent = response;
      dispatch(loadCalendarEventDetailSuccess(event));
    });
  };
}

export function registerForEventFromService(eventId: number, calendarId: number) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.registerForEvent(eventId, calendarId).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // refresh event
      const event: IEvent = response;
      dispatch(loadCalendarEventDetailSuccess(event));
    });
  };
}

export function deleteEventFromService(portletInstanceId: number, objectId: number, parentId: number, contextId: number, deleteThisEventInstanceOnly: boolean, eventInstanceDate: Date) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.deleteEvent(portletInstanceId, objectId, parentId, contextId, deleteThisEventInstanceOnly, eventInstanceDate).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      if (response.error) { throw (response.error); }

      const event: IEvent = response;

      dispatch(refreshEventsFromService());

    }).catch((error) => {
      toastr.error(error);
    });
  };
}

export function refreshEventsFromService() {
  return (dispatch, getState) => {
    // This is used to re-request the events for the calendar, using the calendar's current settings.
    // Called after deleting an event to refresh the displayed events (which will now not include the the deleted event).

    const state: IState = getState();

    const portletInstanceId = state.calendarSettings.portletInstanceId;
    const calendarId = state.calendarSettings.calendarId;
    const otherCalendarIds = state.selectEventsFromOtherCalendarsSettings.checkedNodeCalendarIds.map(Number);
    const localFromDate = state.calendarSettings.localFromDate;
    const localToDate = state.calendarSettings.localToDate;
    const filterField = state.searchToolbar.selectedSearchFilterValue;
    const filterTerm = state.searchToolbar.searchText;
    const category = state.searchToolbar.selectedSearchCategoryValue;
    const filterOptions = state.searchToolbar.searchFilterOptions;

    dispatch(beginAjaxCall());

    return dataService.events(portletInstanceId, calendarId, otherCalendarIds, localFromDate, localToDate, filterField, filterTerm, category, filterOptions).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      // Verify incoming event data.
      let events: IEvent[] = [];
      events = verifyEvents(response);

      // If all's well, dispatch action with the requested events.
      dispatch(loadCalendarEventsSuccess(events));

      // If all's well, dispatch success action to decrement the AJAX request count.
      dispatch(deleteEventSuccess({}));

    });
  };

}

function verifyEvents(rawEvents: any): IEvent[] {

  validateIEventsResponse(rawEvents);

  if (rawEvents.error.trim() === "") {
    const events: IEvent[] = rawEvents.events;
    return events;
  } else {
    throw Error(rawEvents.error);
  }
}

function validateIEventsResponse(data: any): void {
  // Check has expected error and events properties.
  if (data.error === undefined) { throw Error("Events 'error' property is missing."); }
  if (data.events === undefined) { throw Error("Events 'events' property is missing."); }

  // Check error is a string
  if (typeof data.error !== "string") { throw Error("Events 'error' property is not of string type."); }

  // Check events is an array, and contains event objects.
  if (Array.isArray(data.events)) {
    for (let _i = 0; _i < data.events.length; _i++) {
      const event = data.events[_i];
      validateIEvent(event);
      event.anchorId = "id" + event.calendarID + "_" + event.eventID + "_" + _i;
    }
  } else {
    throw Error("Events 'events' property is not an array.");
  }
}

function validateIEvent(data: any): void {
  if (data.calendarID === undefined) { throw Error("Event 'calendarID' property is undefined."); }
  if (data.category === undefined) { throw Error("Event 'category' property is undefined."); }
  if (data.color === undefined) { throw Error("Event 'color' property is undefined."); }
  if (data.eventID === undefined) { throw Error("Event 'eventID' property is undefined."); }
  if (data.icon === undefined) { throw Error("Event 'icon' property is undefined."); }
  if (data.isAllDay === undefined) { throw Error("Event 'isAllDay' property is undefined."); }
  if (data.localStartDate === undefined) { throw Error("Event 'localStartDate' property is undefined."); }
  if (data.localEndDate === undefined) { throw Error("Event 'localEndDate' property is undefined."); }
  if (data.location === undefined) { throw Error("Event 'location' property is undefined."); }
  if (data.name === undefined) { throw Error("Event 'name' property is undefined."); }

  if (data.preformatted_localStartDate === undefined) { throw Error("Event 'preformatted_localStartDate' property is undefined."); }
  if (data.preformatted_localStartDate_screenreader === undefined) { throw Error("Event 'preformatted_localStartDate_screenreader' property is undefined."); }
  if (data.preformatted_localStartTime === undefined) { throw Error("Event 'preformatted_localStartDate' property is undefined."); }
  if (data.preformatted_localEndDate === undefined) { throw Error("Event 'preformatted_localStartDate' property is undefined."); }
  if (data.preformatted_localEndDate_screenreader === undefined) { throw Error("Event 'preformatted_localStartDate_screenreader' property is undefined."); }
  if (data.preformatted_localEndTime === undefined) { throw Error("Event 'preformatted_localStartDate' property is undefined."); }

  if (_.isInteger(data.calendarID) === false) { throw Error("Event 'calendarID' property is not an integer."); }
  if (_.isInteger(data.eventID) === false) { throw Error("Event 'eventID' property is not an integer."); }
  if (_.isBoolean(data.isAllDay) === false) { throw Error("Event 'isAllDay' property is not a boolean"); }
  if (_.isDate(data.localStartDate)) { throw Error("Event 'localStartDate' property is not a valid date."); }
  if (_.isDate(data.localEndDate)) { throw Error("Event 'localEndDate' property is not a valid date."); }

  data.localStartDate = parse(data.localStartDate);
  data.localEndDate = parse(data.localEndDate);
}

function isBoolean(val) {
  return val === false || val === true || val instanceof Boolean;
}
